export default __webpack_public_path__ + "static/media/pencil-hot-autumn.305510df.png";